import React, { useEffect, useState } from 'react';

import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';

// import useAuthService from '@services/auth';

import { useSidebarData } from './hooks';
import { Container, MenuExpandedIcon, MenuItem } from './styles';

/**
 * Componente da sidebar do dashboard
 * Renderiza o menu lateral com navegação baseada nas permissões do usuário
 * @returns {JSX.Element} Componente da sidebar com itens de menu e botão de expansão
 */
const DashboardSidebar = () => {
    // const role_id = useSelector((state) => state.auth.user.role_id);
    const { isLoading, sideBarContent, isSidebarExpanded, handleLeftSidebar, handleClickMenu } = useSidebarData();

    return (
        <Container expanded={isSidebarExpanded} data-tour="2">
            {!isLoading &&
                sideBarContent.length > 0 &&
                sideBarContent.map((menuItem, index) => (
                    <MenuItem
                        key={`menuItem-${index}`}
                        className={location.pathname === menuItem.path && 'active'}
                        menuExpanded={isSidebarExpanded}
                        onClick={() => handleClickMenu(menuItem.path)}
                    >
                        <>
                            <span className={`icon ${menuItem.iconType}`} data-tour={menuItem.dataTour}>
                                {React.isValidElement(menuItem.icon) ? (
                                    <>{menuItem.icon}</>
                                ) : (
                                    <img src={menuItem.icon} alt={menuItem.label} />
                                )}
                            </span>
                            <span className={'title'}>{menuItem.label}</span>
                            <div className={`expanded-title ${!isSidebarExpanded && 'hidden-title'}`}>{menuItem.labelFull}</div>
                        </>
                    </MenuItem>
                ))}
            <MenuExpandedIcon onClick={handleLeftSidebar}>
                {!isSidebarExpanded ? <ChevronRightRoundedIcon /> : <NavigateBeforeRoundedIcon />}
            </MenuExpandedIcon>
        </Container>
    );
};
export default DashboardSidebar;
